<template>
  <div class="ch-component-warpper">
    <div class="ch-component ch-detail-component">
      <v-container fluid grid-list-lg class="ch-menu-wrapper ch-detail-page">
        <v-layout row wrap>
          <v-flex xs-12>
            <!-- <button @click.stop="toogleDrawer" class="ch-menu-btn ch-navigation-toogle" type="button">
              <span class="ch-menu-btn-icon" v-show="navigationDrawer">
                <i class="fas fa-minus fa-fw"></i>
              </span>
              <span class="ch-menu-btn-icon" v-show="!navigationDrawer">
                <i class="fas fa-plus fa-fw"></i>
              </span>
            </button> -->
            <span class="ch-component-title ml-2">HOTEL Detail</span>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-tabs icons class="ch-tabs">
              <v-tabs-bar dark>
                <v-tabs-item
                  v-for="(tab, index) in tabs"
                  :key="index"
                  :to="tab.to"
                  router
                >
                  <i :class="[ tab.icon ]"></i>
                  <span class="tab-title">{{ tab.title }}</span>
                </v-tabs-item>
              </v-tabs-bar>
            </v-tabs>
            <v-slide-x-transition mode="out-in">
              <router-view></router-view>
            </v-slide-x-transition>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  // import { hotelsEventBus } from '@/components/admin/hotels/hotelsEventBus';
  import HotelsDetailInfo from '@/components/admin/hotels/HotelsDetailInfo';
  import BookingsList from '@/components/admin/bookings/BookingsList';

  export default {
    data() {
      return {
        // NOTE: Full screen dialog
        id: null,                           // hotel id
        dialog: false,
        navigationDrawer: true,
        tabs: [
          {
            title: 'INFORMATION',
            to: { name: 'hotelsDetailInfo' },
            icon: 'fas fa-info-circle',
          },
          {
            title: 'PERMISSION',
            to: { name: 'hotelsPermission', params: { hotelId: this.id } },
            icon: 'fas fa-info-circle',
          },
        ],
      };
    },
    methods: {
      // NOTE: toogle navigation drawer
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
    },
    mounted() {
      this.id = this.$route.params.id;
      navigationEventBus.$on('ondrawerHide', () => {
        window.console.log('ondrawerHide');
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        window.console.log('ondrawerShow');
        this.navigationDrawer = true;
      });
      if (localStorage.getItem('domain_type') === 'root') {
        this.tabs.push({
          title: 'BOOKING LIST',
          // to: 'hotelBookingsList',
          to: { name: 'hotelsBookings', params: { hotelId: this.id } },
          icon: 'fas fa-list-alt',
        });
      }
    },
    components: {
      HotelsDetailInfo, BookingsList,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/HotelsDetail.vue